import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Typography } from '@/shared/antd-imports';
import { UpdatesList } from '@/components/updates/UpdatesList';

/** Spec 28 §7.5 (stream abill): Updates — progress updates the provider published on the client's projects. */
const UpdatesPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Flex vertical gap={16} style={{ maxWidth: 880, width: '100%' }}>
      <div>
        <Typography.Title level={3} style={{ marginBottom: 4 }}>
          {t('updates.title', { defaultValue: 'Updates' })}
        </Typography.Title>
        <Typography.Text type="secondary">
          {t('updates.subtitle', { defaultValue: 'Progress updates from your project team.' })}
        </Typography.Text>
      </div>
      <UpdatesList showProject />
    </Flex>
  );
};

export default UpdatesPage;
